module.exports = __webpack_public_path__ + "static/media/anup.5779c161.webp";